<!-- Public session -->
<ng-container *ngIf="isPublicRoute || isBootPage; else privateSession">
  <ng-container *ngIf="(publicLoaderActive$ | async) || (loaderActive$ | async)">
    <sp-loader [flagPagePublic]="true"></sp-loader>
  </ng-container>
  <router-outlet></router-outlet>
</ng-container>

<!-- Private session -->
<ng-template #privateSession>
  <sp-container [env]="env"
                [menuSectionItems]="menuSectionItems$ | async"
                [loggedMerchantAuthority]="tokenAuthority$ | async"
                [username]="username$ | async"
                [localUnits]="localUnits$ | async"
                [flagLocalUnitsDisabled]="localUnitsDisabled$ | async"
                [flagCompletlyDisabled]="localUnitsCompletlyDisabled$ | async"
                (menuItemSelected)="menuItemSelected($event)"
                (logOutBtnEvent)="openLogoutDialog()"
                (localUnitEmitted)="toggleSelectedUnit($event)"
                (allUnitsEmitted)="toggleAllUnits()">
    <ng-container *ngIf="loaderActive$ | async">
      <sp-loader [flagPagePublic]="false"></sp-loader>
    </ng-container>
    <div class="mat-app-background sp-grid-container mat-typography no-padding">
      <div class="outlet-content">
        <router-outlet></router-outlet>
      </div>
    </div>
  </sp-container>
</ng-template>
